import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/store';
import styled from '@emotion/styled';
import EditorBtn from './UI/EditorBtn';

const Cont = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const Modal = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 30px;
  padding: 32px;
  line-height: 1.6;
  z-index: 1001;
  max-width: 600px;
  box-shadow: 0 0 0 12px rgba(0, 0, 0, 0.2);

  & h1 {
    line-height: 2;
  }

  & div {
    line-height: 1.6;
  }

  & button {
    margin: 16px 0;
  }
`;

const errorModal = ({ hasError, error, children }) => {
  if (hasError) {
    // You can render any custom fallback UI
    return (
      <Cont>
        <Backdrop />
        <Modal>
          {children(error)}
          <EditorBtn
            label="Reload"
            onClick={() => {
              window.location.reload();
            }}
          />
        </Modal>
      </Cont>
    );
  }

  return null;
};

export const ErrorModal = connect((state: State) => {
  return {
    hasError: state.hasError,
    error: state.error,
  };
})(errorModal);
